import { Card, CardBody, Table } from "reactstrap";
import { ECommerce, Invoice } from "../../../../../constants";
import { dynamicImage } from "../../../../../utils";
import { InvoiceButtons } from "../common/InvoiceButtons";
import InvoiceDateSection from "./InvoiceDateSection";
import InvoiceHead from "./InvoiceHead";
import InvoiceTable from "./InvoiceTableHead";
import InvoiceTaxSection from "./InvoiceTaxSection";
import Breadcrumbs from "../../../../../coreComponents/breadcrumbs";
import { Image } from "../../../../../coreComponents/Image";

// This component displays the invoice 4, including invoice header, add section, table, amount section, and buttons.
const InvoiceFourContainer = () => {
  return (
    <>
      <Breadcrumbs mainTitle={Invoice} parent={ECommerce} />
      <div className="invoice-2 invoice-4">
        <Card>
          <CardBody>
            <Table borderless>
              <tbody>
                <InvoiceHead />
                <InvoiceDateSection />
                <InvoiceTable />
                <tr className="custom-gradient-row">
                  <td className="custom-gradient-cell" />
                </tr>
                <InvoiceTaxSection />
                <tr className="signature-container">
                  <td className="p-0">
                    <Image src={dynamicImage(`email-template/invoice-3/sign.png`)} alt="sign" />
                    <span className="name">Laurine T. Ebbert</span>
                    <span className="designation">( Designer )</span>
                  </td>
                </tr>
              </tbody>
            </Table>
          </CardBody>
        </Card>
      </div>
      <InvoiceButtons />
    </>
  );
};

export default InvoiceFourContainer;
